export default __webpack_public_path__ + "static/media/FigJam_logo.83944584.svg";